import isURL from 'validator/lib/isURL';
import { phone } from 'phone';

export const isSpecialCharacter: Function = (event: KeyboardEvent): boolean => {
    const keyCode: number = event.keyCode;
    const isSpecialCharacter: boolean = (keyCode > 64 && keyCode < 91) || (keyCode > 96 && keyCode < 123) || keyCode === 8 || keyCode === 32 || (keyCode >= 48 && keyCode <= 57);
    return isSpecialCharacter;
};

export const isWhiteSpace: Function = (event: any): any => {
    const isWhiteSpace: boolean = /^\s+$/.test(event.value);
    return isWhiteSpace ? { 'whitespace': true } : null;
};

export const removeWhiteSpace: Function = (event: any): any => {
    return event.target.value.replace(/\s/gi, '');
};

export const preventWhiteSpace: Function = (event: any): any => {
    if (event.charCode == 32) {
        event.preventDefault();
    }
};

export const insertString: Function = (string: string, index: number, value: string): string => {
    return string.substring(0, index) + value + string.substr(index);
};

export const isValidURL: Function = (url: string): boolean => {
    const isValid: boolean = isURL(url, { require_tld: true, require_protocol: true, protocols: ['http', 'https'], require_host: true, require_valid_protocol: true, allow_underscores: true, host_whitelist: false, host_blacklist: false, allow_trailing_dot: false, allow_protocol_relative_urls: true, disallow_auth: false });
    return isValid;
};

export const stringContains: Function = (word: string, toSearch: string): boolean => {
    const isMatched: boolean = word.indexOf(toSearch) !== -1
    return isMatched;
};

export const isValidPhoneNumber: Function = (selectedPhone: string): boolean => {
    const isPhoneValid: boolean = phone(selectedPhone)["isValid"];
    return isPhoneValid;
}

export const rawURLValidator: Function = (url: string): boolean => {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(url);
}
